export const reports = {
	header: {
		title: "Reportes de reserva",
		description: "Ve el rendimiento de reservas en el período seleccionado",
		selectDate: "Seleccionar fecha",
		filterBySalon: "Filtrar por salón",
	},
	salons: {
		all: "Todos los salones",
		main: "Salón Principal",
		vip: "Salón VIP",
	},
	metrics: {
		totalTables: "Total de mesas",
		totalPeople: "Total de personas",
	},
	charts: {
		generalFlow: {
			title: "Flujo general",
			tooltip: "Gráfico que muestra el flujo de reservas durante el período seleccionado",
		},
		statusPie: {
			title: "Reservas por estado",
			tooltip:
				"Distribución porcentual de las reservas por estado (Acomodados, Cancelados, No asistieron)",
		},
		weekDayFlow: {
			title: "Flujo por día de la semana",
			bestDay: "es tu mejor día",
		},
		averagePeople: {
			title: "Promedio de personas por mesa",
			tooltip: "Promedio de personas por mesa en diferentes rangos",
		},
	},
};
